// extracted by mini-css-extract-plugin
module.exports = {"bookWrapper":"_27yjfEHRpKM-lm4iVhIzVI _3Y7xEtrTgaC28IokfnEvTA"};